import React from 'react';
import { Button, Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

/**
 * One-line page header for the transport create/edit pages: back arrow +
 * title. Replaces the former "Wstecz" button row plus a titled shell Card,
 * so the collapsed section list starts right under the sticky app header.
 */
interface TransportRouteFormPageHeaderProps {
  title: string;
  onBack: () => void;
}

const TransportRouteFormPageHeader: React.FC<TransportRouteFormPageHeaderProps> = ({ title, onBack }) => {
  const { t } = useTranslation(['common']);
  return (
    <div className="transport-route-form-header" data-testid="transport-route-form-header">
      <Button
        type="text"
        shape="circle"
        icon={<ArrowLeftOutlined />}
        onClick={onBack}
        aria-label={t('common:back')}
        title={t('common:back')}
      />
      <Typography.Title level={4} className="transport-route-form-header__title">
        {title}
      </Typography.Title>
    </div>
  );
};

export default TransportRouteFormPageHeader;
